import { mdiMap } from '@mdi/js'

export default [
  {
    title: 'Village',
    to: 'village-list',
    icon: mdiMap,
  },
]
